import ReportPage from "../../components/ReportPage";
import { downloadDistributionDetail } from "../../API";

const schema = {
  title: "Stores Not Selling Report",
  params: [
    { name: "banners", label: "Banner", type: "multiselect", route: "banners", payloadKey: "bannerIds", required: true },
    { name: "products", label: "Products", type: "multiselect", route: "products", cascadesFrom: "manufacturer", fields: ["description", "formatQut", "format"], payloadKey: "productIds", required: false },
  ],
  downloadFn: downloadDistributionDetail,
};

export default function DistributionDetailReport() {
  return <ReportPage schema={schema} />;
}
